import React from 'react';

export const OwnerList = (props) => {
    const user = props.user;
    const fieldType = props.fieldType;
    let userId = null, picture = '', fullName = '';
    if (fieldType == 'ai_owner' || fieldType == 'okr_owner' || fieldType == 'kr_owner') {
        userId = user.userId;
        picture = user.picture;
        fullName = user.fullName;
    }
    else {
        userId = user._source.id;
        picture = user._source.picture;
        fullName = user._source.description;
    }
    return (
        <div className='search-result-row' key={'owner-' + userId}>
            <div className='search-result-col search-result-icon-col'>
                <img src={picture} width="30" height="30" style={{borderRadius: '50%'}} />
            </div>
            <div className='search-result-col search-result-text-col'>
                <div className='truncate'>{fullName}</div>
            </div>
            <div className='search-result-col search-result-remove-col'>
                <i className='icon icon-outline-close-24px' onClick={() => props.removeOwner(user, props.fieldType)}></i>
            </div>
        </div>
    );
}

export const WsList = (props) => {
    const ws = props.ws;
    return (
        <div className='search-result-row' key={'ws-' + ws.id}>
            <div className='search-result-col search-result-text-col'>
                <div className='truncate'>{ws.name}</div>
                <div className='truncate subtext'>{ws.teamName}</div>
            </div>
            <div className='search-result-col search-result-remove-col'>
                <i className='icon icon-outline-close-24px' onClick={() => props.removeOwner(ws, props.fieldType)}></i>
            </div>
        </div>
    );
}

export const OkrCategoryList = (props) => {
    const item = props.item;
    return (
        <div className='search-result-row' key={'okr-cat-' + item.id}>
            <div className='search-result-col search-result-text-col'>
                <div className='truncate'>{item.name}</div>
            </div>
            <div className='search-result-col search-result-remove-col'>
                <i className='icon icon-outline-close-24px' onClick={() => props.removeOwner(item, props.fieldType)}></i>
            </div>
        </div>
    );
}